export const currency = 'USD';
export const SCOPE_3_POSITION = 4;
export const EST_BASE_APP_POINTS = 107;
export const STD_BASE_APP_POINTS = 138;
export const SELF_DATA_LOADING_APP_POINTS = 7;
export const DATA_AUTOMATION_APP_POINTS = 11;
export const SOURCE_CONNECTION_APP_POINTS = 6;
export const MIN_SSC = 0;
export const MAX_SSC = 10;
export const DISCOUNT_ESSENTIALS = 0.46729;
export const DISCOUNT_STANDARD = 0.54348;
export const YEARLY = 12;
export const ADDITIONAL_INDUSTRY_POINT = 3;
export const EST_ACCT_LIMIT = 1000;
export const STD_ACCT_LIMIT = 5000;
export const PREM_ACCT_LIMIT = 100000;

export const tileInfo = {
  est: 'essentials',
  std: 'standard',
  prem: 'premium',
};

export const Pkg = {
  est: 'Essentials',
  std: 'Standard',
  prem: 'Premium',
};

export const QuesSet1 = ['Q1', 'Q2', 'Q3', 'Q7'];
export const QuesSet2 = ['Q1', 'Q2', 'Q3', 'Q4', 'Q5', 'Q6', 'Q7'];
export const QuesSet3 = ['Q1', 'Q2', 'Q3', 'Q4', 'Q7'];
// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30Envzi = '30BZD';
